import React, { useEffect, useState, useRef, useCallback } from "react";
import Input from "../../components/controls/input/customInput/CustomInput";
import InputUnderline from "../../components/controls/input/InputUnderline";
import service from "../../store/services/communications.service";
import clientService from "../../store/services/clients.service";
import portfolioService from "../../store/services/portfolio.service";
import programService from "../../store/services/programs.service";
import projectService from "../../store/services/projects.service";
import {
  AddIconSvg,
  ArrowRepeatAllIcon,
  CalendarIcon,
  ListingIcon,
  MeetingsClockIcon,
} from "../../modules/default-svg";
import Button from "../../components/controls/button";
import Searchable from "../../components/controls/select/CustomSelect";
import _ from "lodash";
import { apiCall } from "../../store/services/service";
import {
  BASE_URL,
  URL_SEARCH_CLIENT_PORTFOLIO,
} from "../../store/services/URL";
import { ColumnConfigProvider } from "../../components/controls/tables/ColumnConfigProvider";
import {
  calculatePageSize,
  communicationCategoryOptions,
  convertToISOString,
  getLabelByType,
} from "../../helpers/utils";
import DropDown from "../../components/controls/dropdown/DropdownFluent";
import Table from "../../components/controls/tables/Table";
import RichTextEditor from "../../components/richTextEditor/RichTextEditor";
import styles from "../meetings/MeetingStyles.module.scss";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import moment from "moment";
import { generalActions } from "../../store/actions";
import { useDispatch } from "react-redux";
import MeetingDays from "../meetings/meetingsDays/MeetingDays";
import meetingStyles from "../meetings/MeetingStyles.module.scss";
import './Communication.scss';
import { utcToLocalTimeString } from "../../utils/systemSettings";
import ListingHeader from "../../components/controls/listingHeader/ListingHeader";
import EntityFileUpload from "../../components/controls/fileUpload/EntityFileUpload";
import { Tooltip } from "bootstrap";
import CalendarReportButton from "../../components/Export/CalendarReportButton";

let tooltipInstance = null;

const Communication = (props) => {
  const {
    clientID,
    projectID,
    programID,
    portfolioID,
    defaultProject,
    defaultProgram,
    defaultPortfolio,
    defaultClient,
    allPlans,
    loading,
    pageLoading,
    pagination,
    getCommunicationPlanRequest,
    createCommunicationPlanRequest,
    updateCommunicationPlanRequest,
    deleteCommunicationPlanRequest,
    overviewType,
    redirectionId,
    onRedirectionComplete,
  } = props;
  const [data, setData] = useState([]);
  const calendarRef = useRef(null);
  const [isCalendarView, setIsCalendarView] = useState(false);
  const permissions = localStorage.getItem("permissions");
  const settings = JSON.parse(localStorage.getItem("settings"));
  const timeFormat = settings.regionalSettings.timeFormat;
  const prevClientId = useRef(null);
  const manualUpdate = useRef({
    client: false,
    portfolio: false,
    program: false,
  });
  const [perPageItems] = useState(calculatePageSize());
  const [pageNum, setPageNum] = useState(1);
  const [isCreate, setIsCreate] = useState(false);
  const [selectedRow, setSelectedRow] = useState({});
  const [title, setTitle] = useState("");
  const [category, setCategory] = useState(0);
  const [audience, setAudience] = useState([]);
  const [medium, setMedium] = useState("");
  const [source, setSource] = useState("");
  const [expeditor, setExpeditor] = useState("");
  const [status, setStatus] = useState("");
  const [highlights, setHighlights] = useState("");
  const [expectedResults, setExpectedResults] = useState("");
  const [isEdit, setIsEdit] = useState(false);
  const [parentType, setParentType] = useState(null);
  const [isHeader, setIsHeader] = useState(true);
  const [ClientId, setClientId] = useState(clientID);
  const [PortfolioId, setPortfolioId] = useState(portfolioID);
  const [ProgramId, setProgramId] = useState(programID);
  const [ProjectId, setProjectId] = useState(projectID);
  const [clientOptions, setClientOptions] = useState([]);
  const [portfolioOptions, setPortfolioOptions] = useState([]);
  const [programOptions, setProgramOptions] = useState([]);
  const [projectOptions, setProjectOptions] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [isAllDay, setIsAllDay] = useState(false);
  const [recurrenceRule, setRecurrenceRule] = useState("");
  const [calendarList, setCalendarList] = useState([]);
  const [calenderEditItem, setCalenderEditItem] = useState(null);
  const [calendarDates, setCalendarDates] = useState({});
  const [isCreateNewRow, setIsCreateNewRow] = useState(false);
  const [deleteId, setDeletedId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [attachments, setAttachments] = useState([]);
  const dispatch = useDispatch();
  const [formErrors, setFormErrors] = useState({
    name: "",
    projectId: "",
  });
  const [tableSearch, setTableSearch] = useState(null);

  const [redirectionItem, setRedirectionItem] = useState(null);
  const [hasProcessedRedirection, setHasProcessedRedirection] = useState(false);

  const fetchData = (pageNumber, pageSize, searchTerm, forceClearSearch = false) => {
    const payload = { page: pageNumber ?? pageNum, size: pageSize ?? perPageItems, search: forceClearSearch ? null : (searchTerm ?? tableSearch) };
    payload.parent = parentType || "Communications";


    payload.parent = "Communications";
    if (clientID) {
      payload.id = clientID;
      payload.parent = "Client";
    }
    if (portfolioID) {
      payload.id = portfolioID;
      payload.parent = "Portfolio";
    }
    if (programID) {
      payload.id = programID;
      payload.parent = "Program";
    }
    if (projectID) {
      payload.id = projectID;
      payload.parent = "Project";
    }

    getCommunicationPlanRequest(payload);
  };
  const searchClientHandler = (value) => {
    if (value === "") {
      setClientOptions([]);
      return;
    }
    clientService
      .searchClientsRequest(value)
      .then((res) => {
        const transformedArray = res.map((obj) => ({
          label: obj.name,
          value: obj.id,
        }));
        setClientOptions(transformedArray);
      })
      .catch(() => {
        setClientOptions([]);
      });
  };

  const searchPortfolioHandler = (value) => {
    if (value === "") {
      setPortfolioOptions([]);
      return;
    }
    const payload = { id: ClientId?.value, searchText: value };
    let queryParam = `?searchTerm=${payload.searchText}`;
    if (ClientId)
      queryParam = `?clientId=${payload.id}&searchTerm=${payload.searchText}`;
    apiCall
      .get({
        url: `${URL_SEARCH_CLIENT_PORTFOLIO}${queryParam}`,
        isAuthToken: true,
      })
      .then((res) => {
        const transformedArray = res.map((obj) => ({
          label: obj.name,
          value: obj.id,
        }));
        setPortfolioOptions(transformedArray);
      })
      .catch(() => {
        setPortfolioOptions([]);
      });
  };

  const searchProgramHandler = (value) => {
    if (value === "") {
      setProgramOptions([]);
      return;
    }
    const payload = { searchText: value };
    let queryParam = `?searchTerm=${payload.searchText}`;

    payload.parent = "Communications";

    if (ClientId) {
      queryParam = `?clientId=${ClientId?.value}&searchTerm=${payload.searchText}`;
    }

    if (PortfolioId) {
      queryParam = `?portfolioId=${PortfolioId.value}&searchTerm=${payload.searchText}`;
    }

    if (ClientId && PortfolioId) {
      queryParam = `?clientId=${ClientId.value}&portfolioId=${PortfolioId.value}&searchTerm=${payload.searchText}`;
    }

    apiCall
      .get({ url: `${BASE_URL}search/Programs${queryParam}` })
      .then((res) => {
        const transformedArray = res.map((obj) => ({
          label: obj.name,
          value: obj.id,
        }));
        setProgramOptions(transformedArray);
      })
      .catch(() => {
        setProgramOptions([]);
      });
  };

  const searchProjectHandler = (value) => {
    if (value === "") {
      setProjectOptions([]);
      return;
    }
    const payload = { searchText: value };
    let queryParam = `?searchTerm=${payload.searchText}`;
    payload.parent = "Communications";

    if (ClientId) {
      queryParam = `?clientId=${ClientId?.value}&searchTerm=${payload.searchText}`;
    }

    if (PortfolioId) {
      queryParam = `?portfolioId=${PortfolioId.value}&searchTerm=${payload.searchText}`;
    }

    if (ProgramId) {
      queryParam = `?programId=${ProgramId.value}&searchTerm=${payload.searchText}`;
    }

    if (ClientId && PortfolioId) {
      queryParam = `?clientId=${ClientId.value}&portfolioId=${PortfolioId.value}&searchTerm=${payload.searchText}`;
    }

    if (ClientId && ProgramId) {
      queryParam = `?clientId=${ClientId.value}&programId=${ProgramId.value}&searchTerm=${payload.searchText}`;
    }

    if (PortfolioId && ProgramId) {
      queryParam = `?portfolioId=${PortfolioId.value}&programId=${ProgramId.value}&searchTerm=${payload.searchText}`;
    }

    if (ClientId && PortfolioId && ProgramId) {
      queryParam = `?clientId=${ClientId.value}&portfolioId=${PortfolioId.value}&programId=${ProgramId.value}&searchTerm=${payload.searchText}`;
    }

    apiCall
      .get({ url: `${BASE_URL}search/Projects${queryParam}` })
      .then((res) => {
        const transformedArray = res.map((obj) => ({
          start: obj.startDate,
          end: obj.endDate,
          label: obj.name,
          value: obj.id,
        }));
        setProjectOptions(transformedArray);
      })
      .catch(() => {
        setProjectOptions([]);
      });
  };

  const handleDelete = (selectedRow) => {
    const id = selectedRow.id;
    const data = { id: id };
    data.parent = "Communications";
    if (clientID) {
      data.parentId = clientID;
      data.parent = "Client";
    }
    if (projectID) {
      data.parentId = projectID;
      data.parent = "Project";
    }
    if (programID) {
      data.parentId = programID;
      data.parent = "Program";
    }
    if (portfolioID) {
      data.parentId = portfolioID;
      data.parent = "Portfolio";
    }
    deleteCommunicationPlanRequest(data);
    setDeletedId(id);
  };

  const handleViewChange = () => {
    setIsCalendarView(!isCalendarView);
    !isCalendarView ? fetchCommunications(!isCalendarView) : fetchData(1, perPageItems);
  }

  const handleEventClick = (clickInfo) => {
    setCalenderEditItem({ id: clickInfo.event._def.extendedProps.parentPlanId });
  };

  const handleAddEvent = (selectInfo) => {
    const startDateUtc = moment(
      selectInfo.allDay
        ? new Date(selectInfo.start.getTime() + 1 * 60 * 1000)
        : selectInfo.start
    ).utc();
    const endDateUtc = moment(
      selectInfo.allDay
        ? new Date(selectInfo.end.getTime() - 1 * 60 * 1000)
        : selectInfo.end
    ).utc();

    setStartDate(startDateUtc.format());
    setEndDate(endDateUtc.format());
    setIsAllDay(selectInfo.allDay);
    handleCreate(true);
  };
  const handleCreate = (isFromCalendar = false) => {
    setCalenderEditItem(null);
    setIsCreate(true);
    setRecurrenceRule("");
    setTitle("");
    setCategory(0);
    setAudience("");
    setMedium("");
    setSource("");
    setExpeditor("");
    setStatus("");
    setHighlights("");
    setExpectedResults("");
  };

  const handleSave = () => {
    const errors = {};
    if (!title) errors["name"] = `The Title field is required.`;

    if (startDate && endDate) {
      const startDateTime = moment().utc(startDate).local();
      const endDateTime = moment().utc(endDate).local();

      if (endDateTime < startDateTime) {
        errors["startDate"] = errors["endDate"] = "";
        dispatch(
          generalActions.showToast({
            title: "Communication Plan Start time must be before end time",
            type: "error",
          })
        );
      }
    }

    setFormErrors(errors);
    if (Object.keys(errors).length) {
      return;
    }

    const payload = {
      Title: title,
      ClientId: ClientId?.value,
      PortfolioId: PortfolioId?.value,
      ProjectId: projectID ? projectID : ProjectId?.value,
      Category: category,
      Audience: audience,
      Medium: medium,
      Source: source,
      Expeditor: expeditor,
      Status: status,
      Highlights: highlights,
      results: expectedResults,
      startTime: startDate,
      endTime: endDate,
      isAllDay: isAllDay,
      isRecurring: recurrenceRule !== "",
      recurrenceRule: recurrenceRule
    };

    const data = { payload };
    if (parentType === null) {
      data.parent = "Communications";
    }
    if (clientID) {
      data.id = clientID;
      data.parent = "Client";
    }
    if (projectID) {
      data.id = projectID;
      data.parent = "Project";
    }
    if (programID) {
      data.id = programID;
      data.parent = "Program";
    }
    if (portfolioID) {
      data.id = portfolioID;
      data.parent = "Portfolio";
    }

    data.isForCalendar = isCalendarView;
    if (isCalendarView) {
      data.period = calendarDates;
    }

    if (Object.keys(selectedRow).length > 0) {
      data.sId = selectedRow.id;
      updateCommunicationPlanRequest(data);
    } else {
      createCommunicationPlanRequest(data);
    }
  };

  const handleCancelAddRow = () => {
    setIsCreateNewRow(false);
    fetchData();
  };

  const getCalendarViewDates = (view = "") => {
    const calendarApi = calendarRef.current.getApi();

    switch (view) {
      case "prev":
        calendarApi.prev();
        break;
      case "next":
        calendarApi.next();
        break;
      case "today":
        calendarApi.today();
        break;
      default:
        break;
    }

    var startDate = moment(calendarApi.view.activeStart).utc().format();
    var endDate = moment(calendarApi.view.activeEnd).utc().format();
    return { startDate, endDate };
  };

  const handlePrevClick = () => {
    fetchCommunications(true, "prev");
  };

  const handleNextClick = () => {
    fetchCommunications(true, "next");
  };

  const handleTodayClick = () => {
    fetchCommunications(true, "today");
  };

  const fetchCommunications = (isForCalendar = false, view = "") => {
    const payload = { page: pageNum, size: perPageItems };
    payload.parent = "Communications";
    if (clientID) {
      payload.id = clientID;
      payload.parent = "Client";
    }
    if (portfolioID) {
      payload.id = portfolioID;
      payload.parent = "Portfolio";
    }
    if (programID) {
      payload.id = programID;
      payload.parent = "Program";
    }

    if (projectID) {
      payload.id = projectID;
      payload.parent = "Project";
    }

    payload.isForCalendar = isForCalendar;
    if (isForCalendar) {
      const datesRange = getCalendarViewDates(view);
      setCalendarDates(datesRange);
      payload.period = {
        startDate: datesRange.startDate,
        endDate: datesRange.endDate
      };
    }
    getCommunicationPlanRequest(payload);
  }
  useEffect(() => {
    fetchData();
  }, [pageNum, perPageItems]);

  useEffect(() => {
    if (allPlans && allPlans.length > 0) {
      if (!isCalendarView) {
        if (isCreateNewRow) {
          setData(
            allPlans.sort((a, b) => {
              return b.isFlagged - a.isFlagged;
            })
          );
          setIsCreateNewRow(false);
        } else {
          if (pageNum === 1) {
            setData(
              allPlans
                .filter((item) => item.id !== deleteId)
                .sort((a, b) => {
                  return b.isFlagged - a.isFlagged;
                })
            );
          } else {
            setData((prevData) => {
              const newMap = new Map(allPlans.map((item) => [item.id, item]));

              const updatedPrevData = prevData.map((item) =>
                newMap.has(item.id) ? newMap.get(item.id) : item
              );

              const prevDataIds = new Set(prevData.map((item) => item.id));
              const newItems = allPlans.filter(
                (shift) => !prevDataIds.has(shift.id)
              );

              return [...updatedPrevData, ...newItems]
                .filter((item) => item.id !== deleteId)
                .sort((a, b) => b.isFlagged - a.isFlagged);
            });
          }
        }
      }
      else {
        const formattedEvents = allPlans.map((plan, index) => ({
          id: `OCC-${index}@${plan.id}`,
          parentPlanId: plan.id,
          isRecurring: plan.isRecurring,
          isAllDay: plan.isAllDay,
          allDay: plan.isAllDay,
          title: plan.title,
          start: plan.startTime,
          end: plan.endTime,
          titleTime: plan.isAllDay ? 'all day' : utcToLocalTimeString(settings, plan.startTime),
          project: plan.project
        }));
        setCalendarList(formattedEvents);
      }
    } else if (allPlans && allPlans.length === 0 && pageNum === 1) {
      setData([]);
      setCalendarList([]);
      setIsCreateNewRow(false);
    }
  }, [allPlans, deleteId, pageNum, isCreateNewRow]);

  const handleAddRow = useCallback(() => {
    setIsCreateNewRow(true);
    const payload = { page: pagination?.TotalPages ?? 1, size: 5 };
    fetchData(payload.page, payload.size);
  }, []);

  const fetchCommunicationPlanDetails = async () => {
    setIsLoading(true);
    service
      .getcommunicationPlanRequest({ id: selectedRow.id })
      .then((commData) => {
        setTitle(commData.title);
        // setMessage(commData.message);
        setCategory(commData.category);
        setAudience(commData.audience);
        setStartDate(commData.startTime);
        setEndDate(commData.endTime);
        setIsAllDay(commData.isAllDay);
        setRecurrenceRule(commData.recurrenceRule);
        setMedium(commData.medium);
        setSource(commData.source);
        setExpeditor(commData.expeditor);
        setHighlights(commData.highlights);
        setExpectedResults(commData.results);
        setStatus(commData.status);
        commData.client
          ? setClientId({
            label: commData.client.name,
            value: commData.client.id,
          })
          : setClientId("");
        commData.portfolio
          ? setPortfolioId({
            label: commData.portfolio.name,
            value: commData.portfolio.id,
          })
          : setPortfolioId("");
        commData.program
          ? setProgramId({
            label: commData.program.name,
            value: commData.program.id,
          })
          : setProgramId("");
        commData.project
          ? setProjectId({
            label: commData.project.name,
            value: commData.project.id,
          })
          : setProjectId("");
        setAttachments(commData.attachments || []);
      })
      .catch(() => {
        dispatch(
          generalActions.showToast({
            title:
              "Something went wrong fetching data. Please try again later.",
            type: "error",
          })
        );
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleEdit = (selectedRow, isEdit) => {
    if (Object.keys(selectedRow).length > 0) {
      isEdit && fetchCommunicationPlanDetails();
    } else {
      if (parentType === null) {
        setClientId("");
        setPortfolioId("");
        setProgramId("");
        setProjectId("");
      }
      setTitle("");
      setCategory(0);
      setAudience("");
      if (!(isCalendarView && isCreate)) {
        setStartDate(null);
        setEndDate(null);
        setIsAllDay(false);
      }

      setRecurrenceRule("");
      setMedium("");
      setSource("");
      setExpeditor("");
      setHighlights("");
      setExpectedResults("");
      setStatus("");
      setAttachments([]);
    }
  }
  useEffect(() => {
    handleEdit(selectedRow, isEdit);
  }, [selectedRow, isEdit]);

  const handleCancel = () => {
    setFormErrors({});
    setIsEdit(false);
    setProjectId("");
    setCalenderEditItem();
  };

  const handleSearch = (filteredData) => {
    setData(filteredData);
  };

  useEffect(() => {
    if (category) {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        name: "",
      }));
    }
    if (ProjectId) {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        projectId: "",
      }));
    }
  }, [ProjectId, category]);

  useEffect(() => {
    if (clientID) {
      setParentType("Client");
      setIsHeader(false);
    }
    if (projectID) {
      setParentType("Project");
      setIsHeader(false);
    }
    if (programID) {
      setParentType("Program");
      setIsHeader(false);
    }
    if (portfolioID) {
      setParentType("Portfolio");
      setIsHeader(false);
    }
  }, [portfolioID, clientID, projectID, programID]);

  useEffect(() => {
    if (defaultProject && defaultProject.hasOwnProperty("name")) {
      setProjectId({
        label: defaultProject.name,
        value: defaultProject.id,
      });
    }
  }, [defaultProject]);

  useEffect(() => {
    if (defaultProgram && defaultProgram.hasOwnProperty("name")) {
      setProgramId({
        label: defaultProgram.name,
        value: defaultProgram.id,
      });
    }
  }, [defaultProgram]);

  useEffect(() => {
    if (defaultPortfolio && defaultPortfolio.hasOwnProperty("name")) {
      setPortfolioId({
        label: defaultPortfolio.name,
        value: defaultPortfolio.id,
      });
    }
  }, [defaultPortfolio]);

  useEffect(() => {
    if (defaultClient && defaultClient.hasOwnProperty("name")) {
      setClientId({
        label: defaultClient.name,
        value: defaultClient.id,
      });
    }
  }, [defaultClient]);

  useEffect(() => {
    if (ProjectId && !manualUpdate.current.program) {
      if (!ClientId && !PortfolioId && !ProgramId && !projectID) {
        projectService
          .getProjectDetailsRequest({
            id: typeof ProjectId === "string" ? ProjectId : ProjectId.value,
          })
          .then((projectData) => {
            manualUpdate.current.program = true;
            manualUpdate.current.portfolio = true;
            manualUpdate.current.client = true;

            projectData.client
              ? setClientId({
                label: projectData.client.name,
                value: projectData.client.id,
              })
              : setClientId("");
            projectData.portfolio
              ? setPortfolioId({
                label: projectData.portfolio.name,
                value: projectData.portfolio.id,
              })
              : setPortfolioId("");
            projectData.program
              ? setProgramId({
                label: projectData.program.name,
                value: projectData.program.id,
              })
              : setProgramId("");
          })
          .catch((error) =>
            console.error("Error fetching project data:", error)
          );
      }
    }
  }, [ProjectId]);

  useEffect(() => {
    if (ProgramId && !manualUpdate.current.portfolio) {
      if (!ClientId && !PortfolioId) {
        programService
          .fetchProgramDataRequest({
            id: typeof ProgramId === "string" ? ProgramId : ProgramId?.value,
          })
          .then((data) => {
            // Mark the next updates as manual to prevent cascading effects
            manualUpdate.current.portfolio = true;
            manualUpdate.current.client = true;

            // Update the state of the parent fields
            data.client
              ? setClientId({ label: data.client.name, value: data.client.id })
              : setClientId("");
            data.portfolio
              ? setPortfolioId({
                label: data.portfolio.name,
                value: data.portfolio.id,
              })
              : setPortfolioId("");
            setProjectId(""); // Clear ProjectId when ProgramId changes
          })
          .catch((error) =>
            console.error("Error fetching program data:", error)
          );
      } else {
        if (!isEdit) {
          setProjectId("");
        }
      }
    }
  }, [ProgramId]);

  useEffect(() => {
    if (PortfolioId && !manualUpdate.current.client) {
      if (!ClientId) {
        portfolioService
          .getPortfolioDetails({
            id:
              typeof PortfolioId === "string"
                ? PortfolioId
                : PortfolioId?.value,
          })
          .then((portfolioData) => {
            manualUpdate.current.client = true;
            portfolioData.client
              ? setClientId({
                label: portfolioData.client.name,
                value: portfolioData.client.id,
              })
              : setClientId("");
            setProgramId("");
            setProjectId("");
          })
          .catch((error) =>
            console.error("Error fetching portfolio data:", error)
          );
      } else {
        if (!isEdit) {
          setProgramId("");
          setProjectId("");
        }
      }
    }
  }, [PortfolioId]);

  useEffect(() => {
    if (ClientId) {
      prevClientId.current = ClientId.value;
    }

    if (ClientId && prevClientId.current !== ClientId.value) {
      setPortfolioId("");
      setProgramId("");
      setProjectId("");
      prevClientId.current = ClientId.value;
    }
    manualUpdate.current.client = false;
    manualUpdate.current.portfolio = false;
    manualUpdate.current.program = false;
  }, [ClientId]);

  const handleCommunicationScheduleChange = (data) => {
    setStartDate(data.startDate);
    setEndDate(data.endDate);
    setIsAllDay(data.allDay);
    setRecurrenceRule(data.recurringRule);
  };

  const formBody = () => {
    return (
      <>
        <InputUnderline
          placeholder="Enter name"
          value={title}
          handleChange={setTitle}
          error={formErrors.name}
          isRequired
          loading={isLoading}
        />
        <div className="d-flex">
          {overviewType !== "Client" &&
            overviewType !== "Portfolio" &&
            overviewType !== "Program" &&
            overviewType !== "Project" && (
              <div className="mt-4 w-50">
                <Searchable
                  label="Client"
                  SelectText="client"
                  selectWd="me-3"
                  searchText={searchClientHandler}
                  options={clientOptions}
                  defaultVal={ClientId}
                  onChange={(e) => {
                    setClientId(e);
                    setPortfolioId("");
                    setProgramId("");
                    setProjectId("");
                  }}
                  loading={isLoading}
                />
              </div>
            )}
          {overviewType !== "Portfolio" &&
            overviewType !== "Program" &&
            overviewType !== "Project" && (
              <div className="mt-4 w-50">
                <Searchable
                  label="Portfolio"
                  SelectText="portfolio"
                  selectWd="me-3"
                  searchText={searchPortfolioHandler}
                  options={portfolioOptions}
                  defaultVal={PortfolioId}
                  onChange={(e) => {
                    setPortfolioId(e);
                    setProgramId("");
                    setProjectId("");
                  }}
                  loading={isLoading}
                />
              </div>
            )}
        </div>
        <div className="d-flex">
          {overviewType !== "Program" && overviewType !== "Project" && (
            <div className="mt-4 w-50">
              <Searchable
                label="Program"
                SelectText="program"
                selectWd="me-3"
                searchText={searchProgramHandler}
                options={programOptions}
                defaultVal={ProgramId}
                onChange={(e) => {
                  setProgramId(e);
                  setProjectId("");
                }}
                loading={isLoading}
              />
            </div>
          )}
          {overviewType !== "Project" && (
            <div className="mt-4 w-50">
              <Searchable
                label="Project"
                SelectText="project"
                selectWd="me-3"
                searchText={searchProjectHandler}
                options={projectOptions}
                defaultVal={ProjectId}
                onChange={(e) => setProjectId(e)}
                errorMessage={formErrors.projectId}
                loading={isLoading}
              />
            </div>
          )}
        </div>
        <div className="d-flex row align-items-start w-100 mb-3 mt-4">
          <div className="col-4">
            <Input
              icon={false}
              value={medium}
              type="text"
              handleChange={setMedium}
              placeholder="Enter Medium"
              label="Medium"
              loading={isLoading}
            />
          </div>
          <div className="col-4">
            <Input
              icon={false}
              value={source}
              type="text"
              handleChange={setSource}
              label="Source"
              placeholder="Enter source"
              loading={isLoading}
            />
          </div>
          <div className="col-4">
            <Input
              icon={false}
              placeholder="Enter audience"
              value={audience}
              type="text"
              handleChange={setAudience}
              label="Audience"
              loading={isLoading}
            />
          </div>
        </div>
        <div className="d-flex row align-items-start w-100 mb-3">
          <div className="col-4">
            <Input
              icon={false}
              value={expeditor}
              type="text"
              handleChange={setExpeditor}
              label="Expeditor"
              placeholder="Enter expeditor"
              loading={isLoading}
            />
          </div>
          <div className="col-4">
            <Input
              icon={false}
              placeholder="Enter status"
              value={status}
              type="text"
              handleChange={setStatus}
              label="Status"
              loading={isLoading}
            />
          </div>
          <div className="col-4">
            <DropDown
              label="Category"
              options={communicationCategoryOptions}
              defaultVal={getLabelByType("communicationCategory", category)}
              onChange={setCategory}
            />
          </div>
        </div>
        {!isLoading && (
          <div className="d-flex row align-items-baseline w-100 mb-3">
            <div className="col-12">
              <MeetingDays
                title="Communication Plan Schedule"
                startDate={startDate}
                endDate={endDate}
                allDay={isAllDay}
                recurringRule={recurrenceRule}
                onChange={handleCommunicationScheduleChange}
              />
            </div>

          </div>
        )}
        <div className="d-flex align-items-start w-100 mb-3">
          <RichTextEditor
            label="Purpose / Highlights"
            content={highlights}
            onChange={setHighlights}
            loading={isLoading}
          />
        </div>
        <div className="d-flex align-items-start w-100 mb-3">
          <RichTextEditor
            label="Expected Results / Key Message"
            content={expectedResults}
            onChange={setExpectedResults}
            loading={isLoading}
          />
        </div>
        <EntityFileUpload
          entityId={selectedRow.id}
          entityType="Communication"
          attachments={attachments}
          onAttachmentsChange={() => {
            if (selectedRow.id) {
              service.getcommunicationPlanRequest({ id: selectedRow.id })
                .then((communicationPlanData) => {
                  setAttachments(communicationPlanData.attachments);
                })
                .catch((error) => {
                  console.error("Error fetching communication plan data:", error);
                });
            }
          }}
          disabled={isLoading || !selectedRow.id}
        />
      </>
    );
  };

  const handleMouseEnter = (info) => {
    const event = info.event;
    const commInfo = event._def.extendedProps;
    const titleTime = commInfo.titleTime ?? "";

    const tooltipContent = `
        <div class="tooltip-inner">
          <div class="${commInfo.project ? 'tooltip-comm-project' : ''}">
           ${commInfo.project ? `${commInfo.project?.name}` : ''}  
          </div>
          <div class="tooltip-comm-title">
            <div class="tooltip-comm-time">
              ${titleTime}
              ${commInfo.isRecurring ? `- Recurring` : ''}
            </div>
            ${event.title}
          </div>
        </div>
      `;

    tooltipInstance = new Tooltip(info.el, {
      title: tooltipContent,
      html: true,
      placement: "bottom",
      trigger: "hover",
      container: "body",
      customClass: "comm-tooltip",
      offset: [0, 8]
    });

    tooltipInstance.show();
  };

  const handleMouseLeave = (info) => {
    if (tooltipInstance) {
      tooltipInstance.dispose();
      tooltipInstance = null;
    }
  };

  const getTimeFormatOptions = () => {
    const timeFormat = settings?.regionalSettings?.timeFormat;
    if (!timeFormat) return { hour: "numeric", minute: "2-digit" };

    const usesAmPm = timeFormat.toLowerCase().includes("a");

    return {
      hour: "numeric",
      minute: "2-digit",
      meridiem: usesAmPm ? "short" : undefined,
      hour12: usesAmPm,
    };
  };

  const handleSearchTrigger = (searchTerm) => {
    if ((!tableSearch && !searchTerm) || (tableSearch === searchTerm)) return;

    let pageNumber = pageNum;
    if (!tableSearch || (tableSearch && !searchTerm) || (tableSearch !== searchTerm)) {
      setData([]); //clear existing data
      pageNumber = 1; //reset to first page
    }

    setTableSearch(searchTerm);
    fetchData(pageNumber, perPageItems, searchTerm, !searchTerm);
  };

  useEffect(() => {
    if (!hasProcessedRedirection && redirectionId) {
      setHasProcessedRedirection(true);
      setRedirectionItem({ id: redirectionId });

      if (onRedirectionComplete) {
        onRedirectionComplete();
      }
    }
  }, [redirectionId]);

  const getReportParentId = () => {
    if (clientID)
      return clientID;
    if (portfolioID)
      return portfolioID;
    if (programID)
      return programID;
    if (projectID)
      return projectID;
  };

  return (
    <ColumnConfigProvider
      tableName={
        parentType ? `${parentType}-Communication Plan` : "Communication Plan"
      }
    >
      <div className="listingScreen position-relative">
        {isHeader && (
          <div className="db_Subheader d-flex justify-content-between align-items-center mb-4">
            <h4>Communication Plans</h4>
            {isCalendarView && (
              <div className="d-flex align-items-center gap-2">
                {permissions?.includes("CommunicationPlan.Create") && (
                  <Button
                    btnClass="d_btn d_btn_primary"
                    icon={<AddIconSvg />}
                    label="Add Communication"
                    clickHandler={handleCreate}
                  />
                )}
              </div>
            )}
            {!isCalendarView &&
              permissions?.includes("CommunicationPlan.Create") && (
                <Button
                  btnClass="d_btn d_btn_primary"
                  icon={<AddIconSvg />}
                  label="Add Communication"
                  clickHandler={handleCreate}
                />
              )}
          </div>
        )}

        <div className={`relative ${!isCalendarView ? 'hidden' : ''}`}>
          
          <div className="d-flex align-items-center gap-2 w-100">
            {
              parentType !== "Communications" &&
              <div className="absolute right-[440px] top-[12px]">
                <CalendarReportButton
                parent={parentType}
                parentId={getReportParentId()}
              />
              </div>
              
            }
            <Button
              btnClass="d_btn ms-12 d_btn_primary absolute right-[300px] top-[12px] !bg-[#ece7fd] !text-[#342c82] !text-[13px]"
              icon={<ListingIcon color="#342c82" />}
              label="Listing View"
              clickHandler={handleViewChange}
            />
          </div>
          <div className="calanderMain">
            <FullCalendar
              ref={calendarRef}
              plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
              headerToolbar={{
                left: "today prev,next",
                center: "title",
                right: "dayGridMonth,timeGridWeek,timeGridDay",
              }}
              initialView="dayGridMonth"
              editable={true}
              selectable={true}
              selectMirror={true}
              dayMaxEvents={true}
              weekends={true}
              events={calendarList}
              eventContent={renderEventContent}
              eventTimeFormat={getTimeFormatOptions()}
              slotLabelFormat={getTimeFormatOptions()}
              slotDuration="01:00:00"
              select={handleAddEvent}
              eventClick={handleEventClick}
              eventResize={(resizeInfo) => { resizeInfo.revert() }}
              eventDrop={(resizeInfo) => { resizeInfo.revert() }}
              eventMouseEnter={handleMouseEnter}
              eventMouseLeave={handleMouseLeave}
              customButtons={{
                prev: {
                  text: "Prev", // Text to display on the button
                  click: handlePrevClick, // Function to handle click event
                },
                next: {
                  text: "Next", // Text to display on the button
                  click: handleNextClick, // Function to handle click event
                },
                today: {
                  text: "Today",
                  click: handleTodayClick,
                },
              }}
            />
          </div>
        </div>
        <div className={`${isCalendarView ? 'hidden' : ''}`}>
          <Table
            parentType={parentType}
            isHeader={isHeader}
            type="Communication Plan"
            rows={data || []}
            body={formBody()}
            searchHandler={handleSearch}
            saveBtnLabel="Save"
            cancelBtnLabel="Cancel"
            setPageNum={setPageNum}
            perPageItems={perPageItems}
            setIsCreate={setIsCreate}
            loading={pageLoading}
            modalLoading={loading}
            isCreate={isCreate}
            pagination={pagination}
            handleSave={() => handleSave()}
            handleDelete={(selectedRow) => handleDelete(selectedRow)}
            handleCancel={() => handleCancel()}
            setIsEdit={setIsEdit}
            setSelectedRow={setSelectedRow}
            clientId={clientID}
            portfolioId={portfolioID}
            programId={programID}
            projectId={projectID}
            handleAddRow={handleAddRow}
            handleCancelAddRow={handleCancelAddRow}
            setData={setData}
            isCalendarView={isCalendarView}
            setIsCalendarView={handleViewChange}
            forceShowEditModal={redirectionItem || calenderEditItem}
            triggerSearch={handleSearchTrigger}
          />
        </div>
      </div>
    </ColumnConfigProvider>
  );
};

const renderEventContent = (eventInfo) => {
  const isRecurring = eventInfo.event._def.extendedProps.isRecurring;
  const titleTime = eventInfo.event._def.extendedProps.titleTime ?? "";

  return (
    <div className={`${meetingStyles.meetingTitleCellContainer} CustomEvent`}>
      <p
        className={`${meetingStyles.meetingTitleCell}`}
      >
        {`${titleTime} - ${eventInfo.event.title}`}
      </p>
      {isRecurring && (
        <div className={meetingStyles.meetingReccuringIconCell}>
          <ArrowRepeatAllIcon />
        </div>
      )}
    </div>
  );
};
export default Communication;
